"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ValueObject_1 = require("../Common/ValueObject");
var ContactStatus;
(function (ContactStatus) {
    ContactStatus["None"] = "None";
    ContactStatus["Added"] = "Added";
    ContactStatus["Hide"] = "Hide";
    ContactStatus["Blocked"] = "Blocked";
    ContactStatus["HideRemoved"] = "HideRemoved";
    ContactStatus["BlockedRemoved"] = "BlockedRemoved";
})(ContactStatus = exports.ContactStatus || (exports.ContactStatus = {}));
class Contact extends ValueObject_1.ValueObject {
    // {
    //   id: string,
    //   name: string,
    //   displayName?: string,
    //   avatar?: string,
    //   isOnline?: boolean,
    //   status?: ContactStatus,
    //   isFavorite?: boolean,
    // }
    constructor(contactObj, para2) {
        super();
        this.id = "";
        this.name = "";
        this.displayName = "";
        this.isFavorite = false;
        this.avatar = "";
        this.isOnline = false;
        this.status = ContactStatus.None;
        if (contactObj instanceof Contact) {
            this.id = contactObj.id;
            this.name = contactObj.name;
            this.displayName = contactObj.displayName;
            this.avatar = contactObj.avatar;
            this.isOnline = contactObj.isOnline;
            if (para2 !== undefined) {
                if (typeof (para2) !== "boolean") {
                    //para2's Type should be enum ContactStatus
                    this.status = para2;
                    this.isFavorite = contactObj.isFavorite;
                }
                else {
                    //para2's Type should be boolean
                    this.status = contactObj.status;
                    this.isFavorite = para2;
                }
            }
            else {
                this.status = contactObj.status;
                this.isFavorite = contactObj.isFavorite;
            }
        }
        else {
            this.id = contactObj.id || this.id;
            this.name = contactObj.name || this.name;
            this.displayName = contactObj.displayName || this.name;
            this.avatar = contactObj.avatar || this.avatar;
            this.isOnline = contactObj.isOnline || this.isOnline;
            this.status = contactObj.status || this.status;
            this.isFavorite = contactObj.isFavorite || this.isFavorite;
        }
    }
    *GetEqualityComponents() {
        yield* [this.id, this.name, this.displayName, this.avatar, this.status, this.isFavorite];
    }
    notFavorite() {
        return new Contact(this, false);
    }
}
Contact.ISFAVORITE_PROPERTY_NAME = "isFavorite";
Contact.Nobody = new Contact({
    id: "",
    name: ""
});
exports.Contact = Contact;
//# sourceMappingURL=Contact.js.map